import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';

import './ImageBlock.css';

export default ({ image, title }) => (
    <div className="image-grid" key={title}>
        <div className="image-grid__item">
            <div className="image-grid__tile">
                <p>{title}</p>
            </div>
        </div>
        <div className="image-grid__item">
            {image && image.localFile && image.localFile.childImageSharp ?
                <Img alt={image.alt} sizes={image.localFile.childImageSharp.sizes} />
                :
                <img src={image && image.source_url} />
            }
        </div>
    </div>
);
